import { render, staticRenderFns } from "./bienestar_pacientes.vue?vue&type=template&id=3718cc57&scoped=true&"
import script from "./bienestar_pacientes.vue?vue&type=script&lang=js&"
export * from "./bienestar_pacientes.vue?vue&type=script&lang=js&"
import style0 from "./bienestar_pacientes.vue?vue&type=style&index=0&id=3718cc57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718cc57",
  null
  
)

export default component.exports